import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="bg-slate-50 min-h-screen font-sans pb-20">
      
      {/* ── 1. HERO BANNER ── */}
      <div className="relative text-white overflow-hidden" style={{ minHeight: '300px' }}>
        <img src="/SG (5).jpg" alt="Privacy Policy" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#001529] via-[#0d2d6b]/90 to-[#0d2d6b]/60" />
        <div className="absolute top-0 right-0 opacity-5 text-[180px] font-black select-none leading-none -mr-8 -mt-8">SGCL</div>
        
        <div className="relative z-10 px-4 md:px-20 py-16 max-w-4xl">
          <span className="bg-govt-orange text-white px-4 py-1 rounded-full text-xs font-black uppercase tracking-widest">
            Privacy Commitment
          </span>
          <h1 className="text-4xl md:text-5xl font-black mt-4 mb-5 leading-tight uppercase italic">
            Privacy <span className="text-govt-orange">Policy</span>
          </h1>
          <p className="text-blue-100 font-bold border-l-4 border-govt-orange pl-5 italic max-w-2xl leading-relaxed text-base">
            Your privacy is highly important to us. This policy outlines how Shramjivi Goodshed Corporation Limited collects, processes, and safeguards your personal data.
          </p>
        </div>

        {/* Tricolor border strip */}
        <div className="absolute bottom-0 left-0 right-0 h-1.5 flex">
          <div className="flex-1 bg-[#FF9933]" />
          <div className="flex-1 bg-white" />
          <div className="flex-1 bg-[#138808]" />
        </div>
      </div>

      {/* ── 2. CONTENT SECTION ── */}
      <div className="container mx-auto px-4 md:px-20 mt-12 max-w-5xl">
        <div className="bg-white rounded-3xl shadow-xl border border-slate-100 p-8 md:p-12 space-y-10 relative overflow-hidden">
          {/* Saffron accent border */}
          <div className="absolute top-0 left-0 right-0 h-1.5 bg-[#FF9933]" />

          {/* Document Header */}
          <div className="border-b border-slate-100 pb-8">
            <h2 className="text-govt-blue font-black text-2xl uppercase tracking-wider">Privacy Policy</h2>
            <div className="mt-4 flex flex-col md:flex-row gap-4 text-xs font-bold text-slate-500 uppercase">
              <p>🌐 <span className="text-slate-700">Websites:</span> www.shramjivicorp.com / www.shramjivicorporation.co.in</p>
              <p>🏢 <span className="text-slate-700">Company:</span> Shramjivi Goodshed Corporation Limited</p>
            </div>
          </div>

          {/* Content sections */}
          <div className="space-y-8 text-slate-600 text-sm leading-relaxed font-semibold">
            
            {/* Section 1 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">1.</span> Introduction
              </h3>
              <p className="pl-6">
                Shramjivi Goodshed Corporation Limited (“SGCL”, “Company”, “we”, “our”, or “us”) is committed to protecting the privacy and personal information of visitors, customers, workers, stakeholders, and users accessing our website.
              </p>
              <p className="pl-6">
                This Privacy Policy explains how information is collected, used, stored, processed, and protected when users visit our website or interact with our services.
              </p>
              <p className="pl-6 font-bold text-govt-blue">
                By accessing or using this website, you agree to the terms outlined in this Privacy Policy.
              </p>
            </section>

            <hr className="border-slate-100" />

            {/* Section 2 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">2.</span> Information We Collect
              </h3>
              <p className="pl-6">
                We may collect the following categories of information:
              </p>
              
              <div className="pl-6 space-y-4">
                <div>
                  <h4 className="text-xs font-black uppercase text-govt-orange mb-1">Personal Information</h4>
                  <ul className="pl-6 list-disc space-y-1 text-slate-700 text-xs font-bold">
                    <li>Name</li>
                    <li>Mobile Number</li>
                    <li>Email Address</li>
                    <li>Postal Address</li>
                    <li>Company/Organization Name</li>
                    <li>Employment Information</li>
                    <li>Identity Verification Information (where applicable)</li>
                  </ul>
                </div>

                <div>
                  <h4 className="text-xs font-black uppercase text-govt-orange mb-1">Technical Information</h4>
                  <ul className="pl-6 list-disc space-y-1 text-slate-700 text-xs font-bold">
                    <li>IP Address</li>
                    <li>Browser Type</li>
                    <li>Device Information</li>
                    <li>Operating System</li>
                    <li>Date and Time of Access</li>
                    <li>Website Usage Data</li>
                  </ul>
                </div>

                <div>
                  <h4 className="text-xs font-black uppercase text-govt-orange mb-1">Voluntarily Submitted Information</h4>
                  <p className="text-xs font-semibold mb-1">Information provided through:</p>
                  <ul className="pl-6 list-disc space-y-1 text-slate-700 text-xs font-bold">
                    <li>Contact Forms</li>
                    <li>Registration Forms</li>
                    <li>Employment Applications</li>
                    <li>Business Enquiries</li>
                    <li>Partnership Requests</li>
                    <li>Feedback and Communication Forms</li>
                  </ul>
                </div>
              </div>
            </section>

            <hr className="border-slate-100" />

            {/* Section 3 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">3.</span> Purpose of Collection
              </h3>
              <p className="pl-6">
                Information collected may be used for:
              </p>
              <ul className="pl-12 list-disc space-y-1 text-slate-700">
                <li>Responding to enquiries and requests.</li>
                <li>Providing company services and support.</li>
                <li>Workforce registration and verification processes.</li>
                <li>Communication regarding projects and services.</li>
                <li>Website administration and security.</li>
                <li>Legal and regulatory compliance.</li>
                <li>Improving user experience and website functionality.</li>
                <li>Internal record keeping and reporting.</li>
              </ul>
            </section>

            <hr className="border-slate-100" />

            {/* Section 4 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">4.</span> Data Protection &amp; Security
              </h3>
              <p className="pl-6">
                SGCL adopts reasonable technical, administrative, and organizational safeguards to protect personal information against:
              </p>
              <ul className="pl-12 list-disc space-y-1 text-slate-700">
                <li>Unauthorized access</li>
                <li>Data loss</li>
                <li>Data misuse</li>
                <li>Alteration</li>
                <li>Disclosure</li>
                <li>Cybersecurity threats</li>
              </ul>
              <p className="pl-6 text-xs text-slate-400 italic">
                While reasonable security measures are implemented, no internet-based transmission can be guaranteed to be completely secure.
              </p>
            </section>

            <hr className="border-slate-100" />

            {/* Section 5 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">5.</span> Cookies Policy
              </h3>
              <p className="pl-6">
                Our website may use cookies and similar technologies to:
              </p>
              <ul className="pl-12 list-disc space-y-1 text-slate-700">
                <li>Improve website performance.</li>
                <li>Analyze website traffic.</li>
                <li>Enhance user experience.</li>
                <li>Maintain session functionality.</li>
              </ul>
              <p className="pl-6 font-bold">
                Users may disable cookies through their browser settings; however, certain website functions may be affected.
              </p>
            </section>

            <hr className="border-slate-100" />

            {/* Section 6 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">6.</span> Information Sharing &amp; Disclosure
              </h3>
              <p className="pl-6 font-bold text-slate-800">
                We do not sell, rent, or trade personal information to third parties.
              </p>
              <p className="pl-6">
                Information may be shared only:
              </p>
              <ul className="pl-12 list-disc space-y-1.5 text-slate-700">
                <li>When required by law.</li>
                <li>Upon lawful government requests.</li>
                <li>To comply with judicial or regulatory requirements.</li>
                <li>To protect legal rights and security interests.</li>
                <li>With authorized service providers operating under confidentiality obligations.</li>
              </ul>
            </section>

            <hr className="border-slate-100" />

            {/* Section 7 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">7.</span> Third-Party Websites
              </h3>
              <p className="pl-6">
                Our website may contain links to external websites operated by third parties. SGCL is not responsible for the privacy practices, content, or security of external websites. Users are advised to review the privacy policies of any third-party websites they visit.
              </p>
            </section>

            <hr className="border-slate-100" />

            {/* Section 8 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">8.</span> External Linking Policy
              </h3>
              <p className="pl-6">
                In order to provide useful information and facilitate access to government resources, this website may include links to official Government of India platforms and public information portals.
              </p>
              
              <div className="pl-6 space-y-4">
                <div className="bg-slate-50 p-5 rounded-2xl border border-slate-100 space-y-2">
                  <h4 className="font-black text-xs uppercase text-govt-orange">National Portal of India</h4>
                  <p className="text-xs font-semibold text-slate-600">
                    Users may access official linking resources through: <a href="https://www.india.gov.in/link-to-us" target="_blank" rel="noopener noreferrer" className="text-govt-blue hover:underline">https://www.india.gov.in/link-to-us</a>
                  </p>
                  <p className="text-xs text-slate-500 font-semibold leading-relaxed">
                    The National Portal of India provides verified graphic banners and linking resources in multiple sizes and formats, including colour and black-and-white versions, for use on websites seeking to establish official links to government resources.
                  </p>
                </div>

                <div className="bg-slate-50 p-5 rounded-2xl border border-slate-100 space-y-2">
                  <h4 className="font-black text-xs uppercase text-govt-orange">MyGov Portal</h4>
                  <p className="text-xs font-semibold text-slate-600">
                    Official citizen engagement banners and promotional materials may be accessed through: <a href="https://www.mygov.in" target="_blank" rel="noopener noreferrer" className="text-govt-blue hover:underline">https://www.mygov.in</a>
                  </p>
                  <p className="text-xs text-slate-500 font-semibold leading-relaxed">
                    Website owners may place hyperlinks directing users to MyGov without obtaining prior written permission. However, informing the MyGov team is encouraged so that future structural or technical changes can be communicated when necessary.
                  </p>
                </div>

                <div className="bg-slate-50 p-5 rounded-2xl border border-slate-100 space-y-2">
                  <h4 className="font-black text-xs uppercase text-govt-orange">Integrated Government Online Directory (IGOD)</h4>
                  <p className="text-xs font-semibold text-slate-600">
                    Official linking resources and government directory references may be accessed through: <a href="https://igod.gov.in" target="_blank" rel="noopener noreferrer" className="text-govt-blue hover:underline">https://igod.gov.in</a>
                  </p>
                  <p className="text-xs text-slate-500 font-semibold leading-relaxed">
                    IGOD provides government directory and institutional linking resources for public information purposes.
                  </p>
                </div>
              </div>

              <p className="pl-6 text-xs text-slate-400 italic font-bold">
                Disclaimer: The inclusion of external links does not imply endorsement by SGCL of any views, products, services, or content available on such websites. Users access external websites at their own discretion and subject to the terms and policies of those websites.
              </p>
            </section>

            <hr className="border-slate-100" />

            {/* Section 9 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">9.</span> User Rights
              </h3>
              <p className="pl-6">
                Users may request access to their personal information, correction of inaccurate information, withdrawal of consent where applicable, or deletion of information, subject to legal requirements. Requests may be submitted through the contact details provided below.
              </p>
            </section>

            <hr className="border-slate-100" />

            {/* Section 10 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">10.</span> Retention of Information
              </h3>
              <p className="pl-6">
                Information will be retained only for as long as necessary to fulfill operational requirements, meet legal obligations, resolve disputes, or maintain business records. After expiration of retention requirements, information may be securely deleted or anonymized.
              </p>
            </section>

            <hr className="border-slate-100" />

            {/* Section 11 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">11.</span> Changes to this Privacy Policy
              </h3>
              <p className="pl-6">
                SGCL reserves the right to update or modify this Privacy Policy at any time without prior notice. Updated versions will be published on the website along with the revised effective date.
              </p>
            </section>

            <hr className="border-slate-100" />

            {/* Section 12 */}
            <section className="space-y-3">
              <h3 className="text-govt-blue font-black text-lg uppercase tracking-wide flex items-center gap-2">
                <span className="text-govt-orange text-xl">12.</span> Contact Information
              </h3>
              <div className="pl-6 space-y-4">
                <p>Shramjivi Goodshed Corporation Limited</p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-xs font-bold text-slate-700 bg-slate-50 p-6 rounded-2xl border border-slate-100 uppercase">
                  <div className="space-y-2">
                    <p>🌐 Website: www.shramjivicorp.com / www.shramjivicorporation.co.in</p>
                    <p>✉️ Email: support@shramjivicorp.com / info@shramjivicorporation.co.in</p>
                    <p>📞 Contact: +91 73659 61803 / +91 97070 55354</p>
                  </div>
                  <div className="space-y-1">
                    <p className="text-[10px] text-govt-orange">Registered Office:</p>
                    <p className="leading-relaxed">
                      D/14, Satyajit Roy Co-operative Market, Champasari More,<br />
                      Ward No. 46, Pradhan Nagar, Siliguri,<br />
                      Darjeeling, West Bengal – 734003
                    </p>
                  </div>
                </div>
              </div>
            </section>

          </div>

          {/* Saffron / Green tricolor banner at the bottom of card */}
          <div className="mt-10 pt-6 border-t border-slate-100 text-center text-[10px] font-black uppercase text-slate-400 tracking-widest">
            © Shramjivi Goodshed Corporation Limited. All Rights Reserved.
          </div>

        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
